// React and Icons
import React from 'react'
import { MdOutlineAddCircleOutline } from 'react-icons/md'

// Components
import LinkButton from '../../components/Custom/Buttons/LinkButton'
import PageHeader from '../../components/Custom/PageHeader/PageHeader'
import SeamlessTextures from '../../components/SeamlessTextures'

// Utils
import useUserStore from '../../utils/state/useUserStore'

const SeamlessTexture = () => {
    const userPermissions = useUserStore((state) => state.user) || []

    return (
        <div>
            <PageHeader>
                <div className='flex gap-2 items-center justify-between w-full'>
                    <div className='flex gap-2 items-center font-medium'>
                        <h1 className='text-2xl'>Seamless Texture</h1>
                    </div>
                    {userPermissions?.includes('seamless-texture:create') ? (
                        <LinkButton
                            icon={<MdOutlineAddCircleOutline className='text-xl' />}
                            to={'/seamless-texture/add'}
                            label={'Add Seamless Texture'}
                        />
                    ) : null}
                </div>
            </PageHeader>
            <SeamlessTextures userPermissions={userPermissions} />
        </div>
    )
}

export default SeamlessTexture